import React, { useState, useEffect } from "react";
import { base44 } from "@voult/api/base44Client";
import { FileText, Loader2, RefreshCw } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

const ACTION_STYLES = {
  card_added: "bg-emerald-100 text-emerald-700",
  card_deleted: "bg-rose-100 text-rose-700",
  token_viewed: "bg-blue-100 text-blue-700",
  token_accessed: "bg-indigo-100 text-indigo-700",
  settings_changed: "bg-yellow-100 text-yellow-700",
  default: "bg-slate-100 text-slate-600",
};

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    base44.entities.ActivityLog.list("-created_date", 100).then(setLogs).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Activity Log</h1>
          <p className="text-sm text-slate-500 mt-0.5">Recent actions in your vault</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition">
          <RefreshCw className="h-4 w-4" /> Refresh
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>
      ) : logs.length === 0 ? (
        <div className="text-center py-20 text-slate-500">
          <FileText className="h-10 w-10 mx-auto mb-3 text-slate-300" />
          <p>No activity recorded yet.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
          {logs.map((log) => (
            <div key={log.id} className="flex items-start gap-4 px-5 py-4">
              <div className={`mt-0.5 flex-shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ${ACTION_STYLES[log.action] || ACTION_STYLES.default}`}>
                {log.action?.replace(/_/g, " ")}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-slate-800">{log.details || "No details"}</p>
                {log.entity_type && <p className="text-xs text-slate-400 mt-0.5">Entity: {log.entity_type}{log.entity_id ? ` · ${log.entity_id.slice(0, 8)}…` : ""}</p>}
              </div>
              <span className="flex-shrink-0 text-xs text-slate-400">
                {log.created_date ? formatDistanceToNow(new Date(log.created_date), { addSuffix: true }) : ""}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}